import type { CSSProperties } from 'react'

const cache = new Map<string, CSSProperties>()

/**
 * Parse a raw CSS declaration string into a React style object.
 *
 * This lets every section keep its inline `style="..."` string *verbatim* from
 * the original bundle — the single biggest guarantee of a pixel-perfect port
 * (no hand-transcription of hundreds of declarations into camelCase objects).
 * The original had no vendor-prefixed or custom (`--x`) properties, so plain
 * kebab→camel conversion is exact.
 */
export function css(str: string): CSSProperties {
  const hit = cache.get(str)
  if (hit) return hit
  const obj: Record<string, string> = {}
  for (const decl of str.split(';')) {
    const i = decl.indexOf(':')
    if (i === -1) continue
    const prop = decl.slice(0, i).trim()
    if (!prop) continue
    const value = decl.slice(i + 1).trim()
    const key = prop.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase())
    obj[key] = value
  }
  const frozen = obj as CSSProperties
  cache.set(str, frozen)
  return frozen
}
